import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import styles from "./Form.module.css";
import consultationService from "../../../services/onlineConsultation";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const BookingForm = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    console.log("Received values:", values);

    setLoading(true);
    console.log("values", values);
    if (values.phoneNo && !values.phoneNo.startsWith("+")) {
      values.phoneNo = `+${values.phoneNo}`;
    }
    try {
      const response = await consultationService.create(values);
      console.log("response", response);
      if (response.success) {
        notification.success({
          message: response.message,
        });
        form.resetFields();
      } else {
        notification.error({
          message:
            response.message ||
            response?.message[0] ||
            "Failed..please try again",
        });
      }
    } catch (info) {
      if (info?.errorFields && Array.isArray(info.errorFields)) {
        info.errorFields.forEach((field) => {
          notification.error({
            message: field.errors?.[0] || "Please check all required fields",
            description: "",
            duration: 3,
          });
        });
      } else {
        console.log("info value", info?.response);
        notification.error({
          message: info?.response?.data?.message || "Something went wrong",
          description: "",
          duration: 3,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.formContainer}>
      <h1 className={styles.title}>Book With Ease</h1>
      <Form
        name="booking_form"
        onFinish={onFinish}
        layout="vertical"
        className={styles.form}
        form={form}
      >
        <Form.Item
          name="name"
          rules={[{ required: true, message: "Please enter your full name" }]}
        >
          <Input placeholder="Full Name*" className={styles.input} />
        </Form.Item>

        {/* <Form.Item
          name="phoneNo"
          rules={[
            { required: true, message: "Please enter your phone number" },
          ]}
        >
          <Input
            placeholder="Please Enter Your Number*"
            className={styles.input}
          />
        </Form.Item> */}
        <Form.Item
          className={`${styles.inputHalf} phone-input-consultation`}
          name="phoneNo"
          rules={[
            {
              required: true,
              message: "Please enter your Phone number!",
            },
          ]}
        >
          <PhoneInput
            country={"in"}
            enableSearch={true}
            specialLabel=""
            disableDropdown={false}
            countryCodeEditable={false}
            placeholder={"Please Enter Your Number*"}
            
          />
          {/* <Input placeholder="Phone Number" /> */}
        </Form.Item>
        <Form.Item
          name="location"
          rules={[{ required: true, message: "Please enter your place" }]}
        >
          <Input
            placeholder="Please Enter Your Place*"
            className={styles.input}
          />
        </Form.Item>

        <Form.Item
          name="message"
          // rules={[{ required: true, message: "Please enter your message" }]}
        >
          <Input
            placeholder="Please Enter Your Message"
            className={styles.input}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className={`${styles.submitButton} bg-primary-500 primary-hover2`}
          >
            Book an Appointment
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default BookingForm;
